var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowsColapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.216195 8.16076C0.504396 8.47344 0.971661 8.47344 1.25986 8.16076L7.52186 1.36683C7.81006 1.05415 7.81006 0.547194 7.52186 0.234512C7.23366 -0.0781698 6.76639 -0.0781698 6.47819 0.234512L0.216195 7.02844C-0.072005 7.34112 -0.0720052 7.84808 0.216195 8.16076Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7839 8.16078C14.0721 7.8481 14.0721 7.34115 13.7839 7.02846L7.52186 0.234512C7.23366 -0.0781698 6.76639 -0.0781698 6.47819 0.234512C6.18999 0.547194 6.18998 1.05418 6.47819 1.36686L12.7402 8.16078C13.0284 8.47347 13.4957 8.47347 13.7839 8.16078Z",
    fill: "#919EAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.21615 13.7654C0.504351 14.078 0.971616 14.078 1.25982 13.7654L7.52181 6.97144C7.81002 6.65876 7.81002 6.1518 7.52181 5.83912C7.23361 5.52644 6.76635 5.52644 6.47815 5.83912L0.21615 12.633C-0.07205 12.9457 -0.0720502 13.4527 0.21615 13.7654Z",
    fill: "#919EAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7838 13.7655C14.072 13.4528 14.072 12.9458 13.7838 12.6332L7.52181 5.83912C7.23361 5.52644 6.76635 5.52644 6.47815 5.83912C6.18995 6.1518 6.18994 6.65888 6.47814 6.97156L12.7401 13.7655C13.0283 14.0782 13.4956 14.0782 13.7838 13.7655Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsColapse);
export default __webpack_public_path__ + "static/media/icon-arrows-colapse.ee4189050dc39122ac29cd1cee7cf5a7.svg";
export { ForwardRef as ReactComponent };